export default "__VITE_ASSET__B4Byla7M__"